module.exports = __webpack_public_path__ + "static/media/AvenirLTStd-Book.106f3a54.eot";